import React from 'react';
import BaseAlert, { BaseAlertProps } from 'libs/core-components/Alert/BaseAlert';
import { colors } from '@99designs/ui/settings';
import styled from 'styled-components';
import { IconSuccess } from '@99designs/icons';

export const StyledSuccessAlert = styled(BaseAlert)`
    background: ${colors.semantic.success};
    color: white;
`;

type SuccessAlertProps = Omit<BaseAlertProps, 'icon'>;

export default function SuccessAlert({ children, ...rest }: SuccessAlertProps) {
    return (
        <StyledSuccessAlert icon={<IconSuccess />} {...rest}>
            {children}
        </StyledSuccessAlert>
    );
}
